import styled from 'styled-components';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';

const Wrapper = styled.div``;

type Props = {
  sport: Sport;
  type: Rarity;
};

export const EssenceLayout = ({ sport, type }: Props) => {
  return (
    <Wrapper>
      {sport} {type}
    </Wrapper>
  );
};
